import React, { useState } from "react";

const SimInputBar = ({ type, placeholder, label, value, onChange, errorMessage, className }) => {
  const [isTouched, setIsTouched] = useState(false);
  const [isMouseOut, setIsMouseOut] = useState(false);

  const handleFocus = () => {
    setIsTouched(true);
  };

  const handleBlur = () => {
    setIsTouched(true);
  };

  const handleMouseLeave = () => {
    setIsMouseOut(true);
  };

  const inputClassNames = `form-control ${errorMessage && !value && isMouseOut ? "border-danger" : ""} ${
    className || ""
  }`;

  return (
    <>
      <div className="sim-input">
        {label && <label>{label}</label>}
        <input
          className={inputClassNames}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onMouseLeave={handleMouseLeave}
        />
        <p className="error-here">{errorMessage && isMouseOut && !value && { errorMessage }}</p>
      </div>
    </>
  );
};

export default SimInputBar;
